import React from 'react';
import { ArrowRight } from 'lucide-react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'white' | 'red';
  children: React.ReactNode;
  icon?: boolean;
}

export const Button: React.FC<ButtonProps> = ({ 
  variant = 'primary', 
  children, 
  icon = true,
  className = '',
  ...props 
}) => {
  // Changed rounded-sm to rounded-lg (8px)
  const baseStyles = "inline-flex items-center justify-between px-6 py-3.5 rounded-lg text-sm font-medium transition-all duration-300 group";
  
  const variants = {
    primary: "bg-black text-white hover:bg-gray-800",
    outline: "border border-gray-300 text-gray-900 hover:bg-gray-50",
    white: "bg-white text-black hover:bg-gray-100",
    red: "bg-gradient-to-br from-[#dc2626] to-[#b91c1c] text-white hover:from-[#d91c1c] hover:to-[#dc2626] shadow-md",
  };

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${className}`}
      {...props}
    >
      <span>{children}</span>
      {icon && (
        <ArrowRight className="w-4 h-4 ml-3 transform group-hover:translate-x-1 transition-transform" />
      )}
    </button>
  );
};